import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { API_URL } from "..";

const EditExpensePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const formRef = useRef(null);

  const [expense, setExpense] = useState(null);
  const [categories, setCategories] = useState([]);
  const [message, setMessage] = useState({ show: false, type: "", text: "" });
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const LocationId = localStorage.getItem('locationID')

  // Fetch Single Expense
  const fetchExpense = async () => {
    try {
      const res = await fetch(`${API_URL}/api/expenses/${id}`);
      const data = await res.json();
      if (res.ok) {
        setExpense(data.expense);
      } else {
        setMessage({ show: true, type: "danger", text: "Failed to load expense" });
      }
    } catch (error) {
      console.log("Error loading expense:", error);
    }
    setLoading(false);
  };

  // Fetch Categories
  const fetchCategories = async () => {
    try {
      const res = await fetch(`${API_URL}/api/expense-category`);
      const data = await res.json();
      setCategories(data);
    } catch (error) {
      console.log("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    fetchExpense();
    fetchCategories();
  }, []);

  const updateExpense = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const form = formRef.current;

    const payload = {
      expense_title: form.expense_title.value,
      expense_amount: form.expense_amount.value,
      expense_date: form.expense_date.value,
      locationId: LocationId,
      categoryId: form.category.value, // FIXED
      reference_type: form.reference_type.value,
      reference_id: form.reference_id.value,
      notes: form.notes.value,
    };

    const res = await fetch(`${API_URL}/api/expenses/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    if (res.ok) {
      setMessage({
        show: true,
        type: "success",
        text: "Expense updated successfully!",
      });

      setTimeout(() => {
        navigate(`/view-expense/${id}`);
      }, 800);
    } else {
      setMessage({
        show: true,
        type: "danger",
        text: data.message || "Failed to update expense",
      });
    }

    setIsSubmitting(false);
  };

  if (loading || !expense) return <p className="text-center mt-4">Loading...</p>;

  return (
    <MasterLayout>
      <Breadcrumb title="Edit Expense" />

      <div className="card p-4">
        <div className="row justify-content-center">
          <div className="col-xxl-8 col-xl-10 col-lg-10 col-md-10">

            {message.show && (
              <div className={`alert alert-${message.type}`}>{message.text}</div>
            )}

            <form ref={formRef} onSubmit={updateExpense}>
              <div className="row">

                {/* Title */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Expense Title</label>
                  <input
                    type="text"
                    defaultValue={expense.expense_title}
                    name="expense_title"
                    className="form-control"
                    required
                  />
                </div>

                {/* Amount */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Amount</label>
                  <input
                    type="number"
                    defaultValue={expense.expense_amount}
                    name="expense_amount"
                    className="form-control"
                    required
                  />
                </div>

                {/* Date */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Expense Date</label>
                  <input
                    type="date"
                    defaultValue={expense.expense_date}
                    name="expense_date"
                    className="form-control"
                    required
                  />
                </div>

                {/* Category Select */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Category</label>
                  <select name="category" className="form-control" required>
                    <option value="">Select Category</option>

                    {categories.map((cat) => (
                      <option
                        key={cat.id}
                        value={cat.id}
                        selected={expense.categoryId === cat.id}
                      >
                        {cat.title}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Reference Type */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Reference Type</label>
                  <input
                    type="text"
                    defaultValue={expense.reference_type}
                    name="reference_type"
                    className="form-control"
                    placeholder="invoice / purchase_order / purchase_bill"
                  />
                </div>

                {/* Reference ID */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Reference ID</label>
                  <input
                    type="number"
                    defaultValue={expense.reference_id}
                    name="reference_id"
                    className="form-control"
                    placeholder="Optional"
                  />
                </div>

                {/* Notes */}
                <div className="col-md-12 mb-3">
                  <label className="form-label">Notes</label>
                  <textarea
                    name="notes"
                    defaultValue={expense.notes}
                    className="form-control"
                    rows="3"
                  ></textarea>
                </div>

              </div>

              {/* Buttons */}
              <div className="d-flex gap-3 justify-content-center mt-3">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Updating..." : "Update Expense"}
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>
    </MasterLayout>
  );
};

export default EditExpensePage;
